





















import Vue from 'vue'
export default Vue.extend({
  name: 'Project',
  data(this: Vue) {
    return {
      active: false
    }
  },
  props: {
    slug: String,
    title: Array,
    img: String,
    roles: Array
  },
  computed: {
    image() {
      return require(`@/assets/thumbnail/${this.img}`)
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.handleScroll()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(this) {
      const project = this.$refs[this.slug] as HTMLElement
      const height = project.getBoundingClientRect().height
      const spacing =
        8 * parseFloat(getComputedStyle(document.documentElement).fontSize)
      const limitTop = 80
      const limitBottom = limitTop + spacing + height
      const projectTop = project.getBoundingClientRect().top

      projectTop >= limitTop && projectTop < limitBottom
        ? (this.active = true)
        : (this.active = false)

      let opacity = 1
      if (projectTop < limitTop && !this.active) {
        opacity = 1 + projectTop / height
      } else if (projectTop >= limitBottom && !this.active) {
        opacity =
          1 - (projectTop - limitBottom) / (window.innerHeight - limitBottom)
      } else {
        opacity = 1
      }
      project.style.opacity = opacity.toString()
    }
  }
})
